'use client';

import { ListMagnifyingGlassIcon } from '@phosphor-icons/react';
import { useTimePilotT } from '@/i18n/useTimePilotT';

/** Figma filter bar shell (`ink/060`, 8px radius, 16/8/4px padding). */
export const STACKED_SOURCES_FILTER_BAR_CLASS =
  'flex w-full min-w-0 cursor-text flex-row items-center gap-[10px] rounded-lg bg-[var(--color-ink-060,#344465)] py-1 pl-4 pr-2';

const filterInputClassName =
  'box-border min-w-0 flex-1 bg-transparent text-base font-medium leading-7 text-[color:var(--text-inverse,#ffffff)] outline-none placeholder:text-[color:var(--text-placeholder,#9ab0c4)]';

type AvailableSourcesFilterBarProps = {
  value: string;
  onChange: (value: string) => void;
  'aria-label'?: string;
  placeholder?: string;
};

export function AvailableSourcesFilterBar({
  value,
  onChange,
  'aria-label': ariaLabel,
  placeholder,
}: AvailableSourcesFilterBarProps) {
  const t = useTimePilotT();
  const resolvedLabel = ariaLabel ?? t('sources.filter');
  const resolvedPlaceholder = placeholder ?? t('sources.filterSources');
  return (
    <div className="box-border w-full px-2">
      <div
        className={STACKED_SOURCES_FILTER_BAR_CLASS}
        onClick={(e) => {
          const input = e.currentTarget.querySelector('input');
          input?.focus();
        }}
      >
        <input
          type="text"
          className={filterInputClassName}
          aria-label={resolvedLabel}
          placeholder={resolvedPlaceholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
            }
          }}
        />
        <div className="shrink-0 rounded-3xl p-2" aria-hidden="true">
          <ListMagnifyingGlassIcon
            size={20}
            className="text-[color:var(--text-placeholder,#9ab0c4)]"
          />
        </div>
      </div>
    </div>
  );
}
